<div class="reset-password-container w-200">

    <div class="title-container mb-4" [ngClass]="{'text-start': !isModal, 'text-center': isModal}">
        <div class="title">{{ "resetPasswordLabel" | translate }}</div>
    </div>
    <form [formGroup]="resetPasswordForm">
        <div class="current-password-container mb-4" *ngIf="showCurrentPassword">
            <p class="label-input mb-1">{{ "Contraseña actual" | translate }}</p>
            <p-password [className]="'p-password-custom'"
                        formControlName="currentPassword" class="w-100"
                        id="currentPassword"
                        [feedback]="false" [toggleMask]="true"
                        [inputStyleClass]="this.resetPasswordForm.get('currentPassword').invalid && this.resetPasswordForm.get('currentPassword').touched ? 'error-class form-control': 'form-control'"
                        [disabled]="isPassInvalid">
            </p-password>
        </div>
        <p class="label-input mb-1">{{ "resetPasswordNewPassword" | translate }}</p>
        <p-password
                [className]="getClassesForPasswordInput()"
                formControlName="password" class="w-100" id="password"
                [feedback]="false" [toggleMask]="true"
                [inputStyleClass]="this.resetPasswordForm.get('password').invalid && this.resetPasswordForm.get('password').touched ? 'error-class form-control':'form-control'">
        </p-password>
        <div class="recommendations-container mt-2 mb-3">
            <ng-container *ngFor="let rule of validationRules">
                <div class="recommendation">
                    <img *ngIf="formIsTouched() && this.resetPasswordForm.get('password').value!=''"
                         [src]="isValidPassword(rule.key)
                         ? 'assets/images/icons/checkmark_success.svg'
                         : 'assets/images/icons/error-process.png'"
                         alt="monex">
                    <div [ngClass]="{'invalid': !isValidPassword(rule.key) && formIsTouched()}" class="d-flex ms-2">
                        <li *ngIf="!(formIsTouched() && this.resetPasswordForm.get('password').value!='')"></li>{{ rule.translation | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
        <p class="label-input mb-1">{{ "resetPasswordConfirmationPasswordLabel" | translate }}</p>
        <p-password [className]="'p-password-custom'"
                    formControlName="confirmPassword" class="w-100"
                    id="confirmPassword"
                    [feedback]="false" [toggleMask]="true"
                    [inputStyleClass]="this.resetPasswordForm.get('confirmPassword').invalid && this.resetPasswordForm.get('password').touched ? 'error-class form-control': 'form-control'"
                    [disabled]="isPassInvalid">

        </p-password>
        <div class="btn-container mt-4" [ngClass]="{'text-center': isModal}">
            <button (click)="savePassword()" class="btn-primary login-btn"
                    [disabled]="!resetPasswordForm?.valid">
                {{ "resetPasswordChangePasswordBtn" | translate }}
            </button>
        </div>
    </form>
</div>
